const initialState = {
  loading: false,
  loadingMore: false,
  boostedAthletes: [],
  boostedManagers: [],
  shoutOutAthletes: [],
  // Offset indices for pagination (sorted client-side by totalAmountSpent)
  _lastDocs: {
    boostedAthletes: 0,
    boostedManagers: 0,
    shoutOutAthletes: 0,
  },
  hasMore: {
    boostedAthletes: false,
    boostedManagers: false,
    shoutOutAthletes: false,
  },
};

const bulletinBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "BULLETIN_BOARD_LOADING":
      return { ...state, loading: true };

    case "BULLETIN_BOARD_SUCCESS":
      return {
        ...state,
        loading: false,
        boostedAthletes: action.payload.boostedAthletes,
        boostedManagers: action.payload.boostedManagers,
        shoutOutAthletes: action.payload.shoutOutAthletes,
        _lastDocs: {
          boostedAthletes: action.payload._lastDocs.boostedAthletes,
          boostedManagers: action.payload._lastDocs.boostedManagers,
          shoutOutAthletes: action.payload._lastDocs.shoutOutAthletes,
        },
        hasMore: {
          boostedAthletes: action.payload.hasMore.boostedAthletes,
          boostedManagers: action.payload.hasMore.boostedManagers,
          shoutOutAthletes: action.payload.hasMore.shoutOutAthletes,
        },
      };

    case "BULLETIN_BOARD_LOAD_MORE_START":
      return { ...state, loadingMore: true };

    case "BULLETIN_BOARD_LOAD_MORE_SUCCESS": {
      const { tab, newItems, lastDoc, hasMore } = action.payload;
      return {
        ...state,
        loadingMore: false,
        [tab]: [...state[tab], ...newItems],
        _lastDocs: { ...state._lastDocs, [tab]: lastDoc },
        hasMore: { ...state.hasMore, [tab]: hasMore },
      };
    }

    case "BULLETIN_BOARD_ERROR":
      return { ...state, loading: false, loadingMore: false };

    default:
      return state;
  }
};

export default bulletinBoardReducer;
